import useAppSelector from '@sportson/core-web/hooks/useAppSelector';

export const getAvailablePartialPaymentOptions = (amount: number) => {
    const partialPaymentOptions = useAppSelector(
        ({ application }) => application.config.options?.productPage?.partialPaymentOptions,
    );
    const monthlyOptions = partialPaymentOptions?.monthlyOptions;
    const downPaymentPriceLimit = partialPaymentOptions?.downPaymentPriceLimit;
    const monthlyPaymentFee = partialPaymentOptions?.monthlyPaymentFee;
    let downPayment = 0;

    type PaymentOption = {
        months: number;
        monthlyCost: number;
    }[];

    type MonthlyOption = {
        monthlyOptions: PaymentOption;
        downPayment: number | null;
    };

    const paymentOptions: PaymentOption = [];
    const partialPaymentResult: MonthlyOption = { monthlyOptions: [], downPayment: null };

    if (amount >= downPaymentPriceLimit) {
        downPayment = amount * 0.15;
        amount *= 0.85;
    }

    if (downPayment) {
        partialPaymentResult.downPayment = Math.round(downPayment);
    }

    if (monthlyOptions) {
        monthlyOptions.map((option) => {
            const priceLimit = option.displayAbovePriceLimit;
            if (amount >= priceLimit) {
                const paymentOption = {
                    months: option.months,
                    monthlyCost: Math.round(amount / option.months + monthlyPaymentFee),
                };
                paymentOptions.push(paymentOption);
            }
        });
    }

    partialPaymentResult.monthlyOptions = paymentOptions;

    return partialPaymentResult;
};
